export const TYPE_POINT = 'Point';
export const TYPE_MULTIPOINT = 'MultiPoint';
export const TYPE_LINESTRING = 'LineString';
export const TYPE_MULTILINESTRING = 'MultiLineString';
export const TYPE_POLYGON = 'Polygon';
export const TYPE_MULTIPOLYGON = 'MultiPolygon';
export const TYPE_GEOMETRY_COLLECTION = 'GeometryCollection';
export const TYPE_FEATURE = 'Feature';
export const TYPE_FEATURE_COLLECTION = 'FeatureCollection';
